export enum IBehaviorType {
  Click = "Click",
  ExitIntent = "Exit Intent",
  ScrollPercentage = "Scroll Percentage",
  TimeOnPage = "Time On Page",
}

export enum ContentTypeName {
  Text = "Text",
  Image = "Image",
}

export interface IContent {
  id: number;
  text: string | null;
  imageUrl: string | null;
  imageId: number | null;
  imageAltText: string | null;
  imageName: string | null;
  hideZone: boolean | null;
}

export interface ITriggerContent {
  pageUrl: string;
  zoneShortCode: string;
  pageShortCode: string;
  zoneId: number;
  zoneName: string;
  content: IContent;
  contentType: ContentTypeName;
}

export interface ITrigger {
  behaviorId: number;
  triggerId: number;
  behaviorPageShortCode: string | null;
  behaviorZoneCode: string;
  behaviorType: IBehaviorType;
  behaviorParameter: string;
  triggerContent: ITriggerContent[];
}

export interface ITriggeredContentByPage extends ITriggerContent {
  triggerApplied: boolean;
  timeTriggered: string;
  triggerId: number;
  behaviorId: number;
}

export type TriggerPageUrl = string;
export type TriggerPageShortCodeAndZoneName = string;

export type ITriggersByPageUrl = Record<
  TriggerPageUrl,
  { triggers: ITrigger[] }
>;

export type ITriggerResponse = {
  triggersByPage: ITriggersByPageUrl;
  universalTriggers: ITrigger[];
};

export interface IContentResponse {
  clusterId: number;
  clusterVersionId: number;
  experimentId: number;
  experimentVariationId: number;
  domainId: number;
  content: any[];
  internalSessionId: number;
}

export interface IPersistedExperience {
  triggerId: number;
  behaviorId: number;
  behaviorType: IBehaviorType;
  pageUrl: string;
  /* For server  */
  timestamp: string;
  /* For batting cage script   */
  utcTimestamp: string;
}

export interface IBattingCageCookie {
  meta: {
    /**
     * BS script always expects internal_session_id to be present in non preview mode. If the O&O
     * site is loaded and the script can not find the internal_session_id cookie, or it is null/undefined,
     * the script will not run
     */
    internalSessionId: number | null;
  };
  // If not persistedExperience content, client side script will set persistedExperience to null
  persistedExperience: IPersistedExperience[] | null;
}

export interface IBattingCagePreviewTriggersCookie {
  name: string;
  originalUrlParams: string;
  isActiveTab: boolean;
  scriptTracked: boolean;
  persistedExperience: IPersistedExperience[] | null;
}

export enum IEventLoggerEnum {
  TriggerCreated = "TriggerCreated",
  TriggerActivated = "TriggerActivated",
  TriggerFailed = "TriggerFailed",
  TriggerRetry = "TriggerRetry",
  SessionStarted = "SessionStarted",
  SessionEnded = "SessionEnded",
  PageLoaded = "PageLoaded",
  PageExited = "PageExited",
  ContentRendered = "ContentRendered",
  ContentUpdated = "ContentUpdated",
  ContentRenderedFailed = "ContentRenderedFailed",
  ContentUpdateFailed = "ContentUpdateFailed",
  GenericError = "GenericError",
  Warning = "Warning",
}

export type IEventLoggerPayloadModel = Record<any, any>;

export interface IEventLoggerModel {
  eventType: IEventLoggerEnum;
  createdDate: string | null;
  requestedBy?: string | null;
  domainPageUrl: string;
  internalSessionId: number;
  ipAddress: string | null;
  userAgent: string | null;
  message: string | null;
  payload: IEventLoggerPayloadModel | null;
  domainId?: number | null;
  domainPageId?: number | null;
  clusterId?: number | null;
  clusterVersionId?: number | null;
  experimentId?: number | null;
  experimentVariationId?: number | null;
}
